<template>
	<div>
		<navpage ref="navPage" :middle="true" pagename="listarray"></navpage>

		<div id="content-page">
			<div class="row dynvibeRow">
				<div class="col-lg-12">
					<button
						class="dynvibeButton dynvibeBtnNavig addInterestSegment"
						data-type="segment"
						style="padding: 10px"
						@click="addElement(false)"
					>
						Add
						{{ pageName }}
					</button>
				</div>
			</div>
			<div class="row dynvibeRow" :key="key">
				<div class="col-lg-12">
					<p>Total : {{ totalElements }}</p>
				</div>
			</div>
			<div class="row">
				<div class="col-lg-12">
					<table class="table table-striped dynvibeTable" id="refresh_table_segments">
						<thead style="width: 100%">
							<tr>
								<th class="col-xs-3">Label</th>
								<th class="col-xs-9">Actions</th>
							</tr>
						</thead>
						<tbody style="overflow-y: unset">
							<tr v-for="(element, i) in elements" :key="i" class="col-xs-12">
								<td class="col-xs-3 label_segment" :id="element._id" :data-label="element.label">
									{{ element.label }}
								</td>
								<td class="col-xs-1">
									<span v-if="pageName == 'segment'">
										<span
											class="dynvibeTableActions showhideInterestSegment"
											ref="hide_element"
											v-if="element.hidden !== undefined && element.hidden"
											data-type="segment"
											:id="element._id"
											:data-label="element.label"
											style="cursor: pointer; display: inline-block"
											title="Show / Hide"
											@click="showHide(element)"
										>
											<i class="fas fa-eye-slash"></i>
										</span>
										<span
											class="dynvibeTableActions showhideInterestSegment"
											ref="show_element"
											v-else
											data-type="segment"
											:id="element._id"
											:data-label="element.label"
											style="cursor: pointer; display: inline-block"
											title="Show / Hide"
											@click="showHide(element)"
										>
											<i class="fas fa-eye"></i>
										</span>
									</span>
									<span
										class="dynvibeTableActions far fa-edit editInterestSegment"
										data-type="segment"
										:id="element._id"
										:data-label="element.label"
										style="cursor: pointer; display: inline-block"
										title="Edit"
										@click="
											oldValue = element.label;
											addElement(true, element.label);
										"
									></span>
									<span
										class="dynvibeTableActions fas fa-trash-alt deleteInterestSegment"
										data-type="segment"
										:id="element._id"
										:data-label="element.label"
										style="cursor: pointer; display: inline-block"
										title="Delete"
										@click="deleteElement(element.label)"
									></span>
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<confirm
				ref="confirminput"
				:color="confirmColor"
				:type="confirmType"
				:title="confirmTitle"
				@answerconfirm="treatConfirm($event)"
			>
				<template v-slot:confirm-body>
					{{ confirmMessage }}
					<div v-if="displayInput">
						<input v-model="inputValue" autofocus class="form-control" type="text" />
					</div>
				</template>
			</confirm>

			<confirm ref="confirm" :color="confirmColor" :title="confirmTitle" :type="confirmType" @answerconfirm="treatConfirm($event)">
				<template v-slot:confirm-body>{{ confirmMessage }}</template>
			</confirm>
		</div>
	</div>
</template>
<script>
import navpage from "@/components/globalVue/Nav.vue";
import confirm from "@/components/globalVue/Confirm.vue";
export default {
	name: "segment",
	props: ["page"],
	data() {
		return {
			totalElements: "",
			elements: {},
			oldValue: "",
			newValue: "",
			pageName: this.$props.page,
			displayInput: false,
			query: "",
			inputValue: "",
			key: 0,
			action: "",
			confirmColor: "",
			confirmTitle: "",
			confirmType: "",
			confirmMessage: "",
		};
	},
	components: {
		navpage: navpage,
		confirm: confirm,
	},
	methods: {
		loadComponent() {
			if (this.$props.page == "segment") {
				this.getData("listSegments");
			} else if (this.$props.page == "interest") {
				this.getData("listInterests");
			}
		},
		treatResponse(response) {
			this.totalElements = response.data.totalElements;
			this.elements = response.data.elements;
		},
		treatConfirm(event) {
			this.$refs.confirminput.close();
			this.confirmLoadingModal("open");
			this.inputValue = this.inputValue.trim();
			if (event == "OK" && this.query != "") {
				this.confirmLoadingModal("open");
				let url;
				let target;
				let refresh;

				if (this.$props.page == "segment") {
					target = "segment";
					url = this.$backendUrl + "segments";
					refresh = "listSegments";
				} else if (this.$props.page == "interest") {
					target = "interest";
					url = this.$backendUrl + "interestsMiddle";
					refresh = "listInterests";
				}

				if (this.inputValue === this.oldValue) {
					this.confirmLoadingModal("close");
					return false;
				}
				if (this.inputValue != "") {
					if (this.query == "addElement") {
						let params = {
							action: this.action,
							id: "0",
							label: this.inputValue,
							oldLabel: this.oldValue,
							target: target,
						};
						this.$axios
							.post(url, this.$Qs.stringify(params))
							.then((response) => {
								if (response.data.isOk) {
									this.confirmSuccessModal("Element " + this.inputValue + " has been added.");
									this.getData(refresh);
								} else {
									this.confirmErrorModal("This element already exist.");
									return false;
								}
							})
							.catch(() => {
								this.confirmErrorModal("Element " + this.inputValue + " has not been added.");
							});
					}
				} else if (this.inputValue == "" && this.query == "deleteElement") {
					let params = {
						action: this.action,
						id: "0",
						label: this.oldValue,
						target: target,
					};
					this.$axios
						.post(url, this.$Qs.stringify(params))
						.then((response) => {
							if (response.data.isOk) {
								this.confirmSuccessModal("Element " + this.oldValue + " has been deleted.");
								this.getData(refresh);
							}
						})
						.catch(() => {
							this.confirmErrorModal("Element " + this.oldValue + " has not been deleted.");
						});
				} else {
					this.confirmErrorModal("Cannot add empty element");
				}
			} else {
				this.confirmLoadingModal("close");
			}
		},
		addElement(edit, label) {
			this.confirmInputAddModal("Enter a new " + this.pageName);
			this.displayInput = true;
			this.query = "addElement";

			if (edit == true) {
				this.confirmTitle = "Edit " + this.pageName;
				this.oldValue = label;
				this.action = "edit";
				this.inputValue = label;
			} else {
				this.confirmTitle = "Add " + this.pageName;
				this.oldValue = "";
				this.action = "add";
				this.inputValue = "";
			}
			this.$refs.confirminput.open();
		},
		deleteElement(label) {
			this.confirmInputDeleteModal("Are you sure to delete: " + label + "? ");

			this.displayInput = false;
			this.query = "deleteElement";
			this.action = "delete";
			this.oldValue = label;
			this.inputValue = "";
			this.$refs.confirminput.open();
		},
		showHide(element) {
			let params = new URLSearchParams();
			params.append("action", "showhide");
			params.append("id", "0");
			params.append("label", element.label);
			params.append("target", "segment");
			this.$axios.post(this.$backendUrl + "segments", params).then((response) => {
				console.log(response);
				this.getData("listSegments");
				element.hidden = !element.hidden;
			});
		},
	},
};
</script>
